module.exports = __webpack_public_path__ + "img/invest_plan_2.1f5ebc06.svg";